import { ReactNode } from 'react'
import { customerLogos } from './customers'

export type Quote = {
  cite: string
  quote: string | ReactNode
  logo?: string
  cta?: string
  ctaLabel?: string
  title: string
}

export const QuoteAviatrix: Quote = {
  cite: 'Cody Pulliam, Senior Manager of Business Analytics',
  logo: customerLogos.aviatrix,
  quote: `Compared to Tableau and Looker, Omni was by far the best performer in terms of all-around functionality.`,
  cta: '/blog/case-study-aviatrix',
  title: 'Aviatrix',
}

export const QuoteAviatrix2: Quote = {
  cite: 'Cody Pulliam, Senior Manager of Business Analytics, Aviatrix',
  logo: customerLogos.aviatrix,
  quote: `Despite having a complex model, a large backlog of content, and more than 100 users, we were able to complete the migration to Omni in just three weeks with the help of Omni's team.`,
  cta: '/blog/case-study-aviatrix',
  title: 'Aviatrix',
}

// export const QuoteAviatrix3: Quote = {
//   cite: 'Travis Mitchell, Sr Principal Product Operations Manager',
//   logo: customerLogos.aviatrix,
//   quote: `Wow, AI did something useful for me 🙂`,
//   title: 'Aviatrix',
// }

export const QuoteCheckr: Quote = {
  cite: 'Sarah Fischbach, Staff Analytics Engineer, Checkr',
  logo: customerLogos.checkr,
  quote: `The semantic layer is deterministic and precise; it defines what calculations exist. We use Omni's AI context to be conversational and contextual, to help AI understand how we talk. We don't duplicate across the layers; we use them to translate so that Omni's agent can have a real conversation with someone who understands our business but doesn't write SQL.`,
  cta: '/blog/case-study-checkr',
  title: 'Checkr',
}

export const QuoteCheckr2: Quote = {
  cite: 'Sarah Fischbach, Staff Analytics Engineer, Checkr',
  logo: customerLogos.checkr,
  quote: `There's relevant, untapped business context everywhere. Omni stands out because it makes all of our knowledge structured and durable for smarter AI.`,
  cta: '/blog/case-study-checkr',
  title: 'Checkr',
}

export const QuoteDatabricks: Quote = {
  cite: 'Andrew Ferguson, VP of Databricks Ventures',
  logo: customerLogos.databricks,
  quote: `At Databricks, we're focused on making data and AI accessible to everyone. A key part of that is bridging the gap between technical data teams and business users. We're excited to invest in and partner with Omni as the first business intelligence company in the Databricks Ventures portfolio. Omni's approach to business intelligence aligns with our vision for the future of data and AI, and we look forward to supporting their continued growth and success.`,
  title: 'Databricks',
  cta: '/blog/case-study-databricks',
}

export const QuoteDatabricksPartner: Quote = {
  cite: 'Andrew Ferguson, VP of Databricks Ventures',
  logo: customerLogos.databricks,
  quote: `At Databricks, we're focused on making data and AI accessible to everyone. A key part of that is bridging the gap between technical data teams and business users. We're excited to invest in and partner with Omni as the first business intelligence company in the Databricks Ventures portfolio. Omni's approach to business intelligence aligns with our vision for the future of data and AI, and we look forward to supporting their continued growth and success.`,
  title: 'Databricks',
  cta: '/databricks',
}

export const QuoteTheRounds2: Quote = {
  cite: 'Griffin Tschurwald, Head of Engineering',
  logo: customerLogos.theRounds,
  cta: '/blog/case-study-the-rounds',
  quote: `We have a lot of people who are Excel power users and they love the
  ability to pivot quickly in Omni.`,
  title: 'The Rounds',
}

// export const QuoteRoseRocket = {
//   cite: 'Jade Khiev, Insights Engineering Lead',
//   logo: customerLogos.roseRocket,
//   quote: `Redefining our product and go-to-market strategy has resulted in exceptional growth, but it also meant we needed to maximize the flexibility, performance, and ease of data access. By using Omni and Snowflake, our internal users can self-serve and get faster answers. This frees up our technical resources to focus on delivering the best product and customer experience.`,
//   cta: '/blog/case-study-rose-rocket',
//   title: 'Rose Rocket',
// }

// export const QuoteRoseRocket2 = {
//   cite: 'Jade Khiev, Insights Engineering Lead',
//   logo: customerLogos.roseRocket,
//   quote: `It's very intuitive. We've received feedback from many of our co-workers that Omni just feels so much easier than Looker.`,
//   cta: '/blog/case-study-rose-rocket',
//   title: 'Rose Rocket',
// }
// export const QuoteRoseRocket3 = {
//   cite: 'Jade Khiev, Insights Engineering Lead',
//   logo: customerLogos.roseRocket,
//   quote: `Migrating to Omni allowed my team to hand off most of the day-to-day internal analytics needs so we can focus on our platform and building new value for our customers.`,
//   cta: '/blog/case-study-rose-rocket',
//   title: 'Rose Rocket',
// }

export const QuoteSWBC: Quote = {
  cite: 'Austin Aranda, Director of Data Solutions',
  logo: customerLogos.swbc,
  quote: `Omni's AI answered like a consultant and provided recommendations that aligned with a proposal our team was already pursuing. It validated the AI's capabilities and helped us build stakeholder confidence — giving our stakeholders confidence and strengthening alignment around SWBC's AI vision.`,
  cta: '/blog/case-study-swbc',
  title: 'SWBC',
}

export const QuoteOrdermentum: Quote = {
  cite: 'Sophie Paulin, Chief Marketing Officer',
  logo: customerLogos.ordermentum,
  quote: `Our data team has aligned data properties with the terms we use every day. Now, I can just open up Blobby, Omni's AI assistant, and ask exactly what I'm looking for — like 'Who were our top suppliers last month based on GMV growth?' The level of detail is excellent, and honestly, it's actually fun to use.`,
  cta: '/blog/case-study-ordermentum',
  title: 'Ordermentum',
}

// export const QuoteTrint: Quote = {
//   cite: 'Anya Osen Barnett, Senior Analytics Engineer',
//   logo: customerLogos.trint,
//   quote: `I really love Snowflake's SQL syntax. It's just more advanced than other dialects of SQL. When you're trying to duplicate something, you'd normally have to create another CTE, and that ends up being very bulky. With Snowflake, you can just use the QUALIFY clause instead.`,
//   cta: '/blog/case-study-trint',
// }

export const QuoteTrint4: Quote = {
  cite: 'Anya Osen Barnett, Senior Analytics Engineer',
  logo: customerLogos.trint,
  quote: `Omni opens up data exploration to more people on the team. Our previous tool required expertise in SQL or a custom coding language to do calculations, but Omni Calculations use Excel syntax which makes things much easier for people.`,
  cta: '/blog/case-study-trint',
  title: 'Trint',
}

// export const QuoteSnowflake: Quote = {
//   cite: 'Josh Klahr, Head of Data Warehousing at Snowflake & Harsha Kapre, Director at Snowflake Ventures',
//   logo: customerLogos.snowflake,
//   quote: `Omni's built-in semantic model helps data teams quickly build enterprise data applications. Being able to validate metric definitions allows users to improve the accuracy of models to produce trustworthy results, which is essential for enterprise AI use cases.`,
//   cta: '/blog/snowflake-invests-in-omni',
//   ctaLabel: 'Learn More',
//   title: 'Snowflake',
// }

export const QuoteSnowflakePartner: Quote = {
  cite: 'Josh Klahr, Head of Data Warehousing at Snowflake & Harsha Kapre, Director at Snowflake Ventures',
  logo: '/images/partners/snowflake.svg',
  quote: `Omni's built-in semantic model helps data teams quickly build enterprise data applications. Being able to validate metric definitions allows users to improve the accuracy of models to produce trustworthy results, which is essential for enterprise AI use cases.`,
  cta: '/snowflake',
  ctaLabel: 'Learn More',
  title: 'Snowflake',
}

// export const QuoteMiddleware: Quote = {
//   cite: 'Zach Michel, Co-founder',
//   logo: customerLogos.middleware,
//   quote: `We wanted a tool that had all the features we needed in a single platform and would make everyone's life easier. After testing it, choosing Omni was an easy decision.`,
//   cta: '/blog/case-study-middleware',
//   title: 'Middleware',
// }

export const QuoteIncidentIo: Quote = {
  cite: 'Jack Colsey, Analytics Manager, incident.io',
  logo: customerLogos.incidentio,
  quote: `The transition from custom SQL in Metabase to a semantic layer in Omni was an opportunity to 'slow down to speed up'. By migrating to Omni, we were able to consolidate the number of dashboards in our BI tool by 5x.`,
  cta: '/blog/case-study-incident-io',
  title: 'Incident.io',
}

export const QuoteIncidentIo2: Quote = {
  cite: 'Jack Colsey, Analytics Manager, incident.io',
  logo: customerLogos.incidentio,
  quote: `The transition from custom SQL in Metabase to a semantic layer in Omni was an opportunity to "slow down to speed up." By migrating to Omni, we were able to consolidate the number of dashboards in our BI tool by 5x.`,
  cta: '/blog/case-study-incident-io',
  title: 'Incident.io',
}

export const QuoteUscreen: Quote = {
  cite: 'Joe Horowitz, VP of Growth & Analytics',
  logo: customerLogos.uscreen,
  quote: `We want to own our business logic, so the dbt <> git workflow works well for us. None of the other vendors seemed to offer that flexibility, but Omni's bi-directional dbt integration really stood out to us as something that aligned with our philosophy. Beyond technical alignment, Omni seemed like the right partner as a company; it was by far the best sales experience I've had. I believe in the future with Omni.`,
  cta: '/blog/case-study-uscreen',
  title: 'Uscreen',
}

export const QuoteUscreen4: Quote = {
  cite: 'Joe Horowitz, VP of Growth & Analytics, Uscreen',
  logo: customerLogos.uscreen,
  quote: `We want to own our business logic, so the dbt <> git workflow works well for us. Omni's bi-directional dbt integration really stood out.`,
  cta: '/blog/case-study-uscreen',
  title: 'Uscreen',
}

export const QuoteAura: Quote = {
  cite: 'Setareh Lotfi, CTO',
  logo: customerLogos.aura,
  quote: `A lot of our non-technical users are able to upload data that doesn't live in our data warehouse; it's fantastic because they don't need engineering resources to do their work. As someone who leads engineering, Omni's helped open up my bandwidth because I don't have to give up as much engineering time and resources to help people do their jobs.`,
  title: 'Aura',
}

export const QuoteBuzzfeed: Quote = {
  cite: 'Lizzy Bradford, Senior Director of Analytics',
  logo: customerLogos.buzzfeed,
  quote: `Using Omni has reduced the number of new questions and consolidated the reports our Analytics team needs to build. It's given us time back while giving our stakeholders more independence to explore what they need.`,
  cta: '/blog/case-study-buzzfeed',
  title: 'Buzzfeed',
}

export const QuoteBuzzfeed2: Quote = {
  cite: 'Lizzy Bradford, Senior Director of Analytics',
  logo: customerLogos.buzzfeed,
  quote: `Receiving emailed reports and alerts has been key to our workflow for years. With Omni, we can add more data into those reports to alert us about changes or issues that need attention. It's much easier to monitor our product when everything is in one place.`,
  cta: '/blog/case-study-buzzfeed',
  title: 'Buzzfeed',
}

export const QuoteBuzzfeed3: Quote = {
  cite: 'Lizzy Bradford, Senior Director of Analytics, BuzzFeed',
  logo: customerLogos.buzzfeed,
  quote: `Creating the Omni data model was very fast compared to what we were used to. The generation of the initial model code in Omni is so easy — instantly syncing with our warehouse and having views available saved us a lot of time. We built a lot of curated datasets (Topics) and had dashboards ready in a couple of weeks.`,
  cta: '/blog/case-study-buzzfeed',
  title: 'BuzzFeed',
}
export const QuoteCribl: Quote = {
  cite: 'Laura Knipe, Staff Data Analyst, Sales & Finance',
  logo: customerLogos.cribl,
  quote: `Spreadsheets have been a total game changer for our ARR reporting. It feels like Excel, but it's fully connected to our live data. We no longer have to download data in order to analyze it how we want to, and we can keep reporting consistent, which has been a huge help to stakeholders.`,
  cta: '/blog/case-study-cribl',
  title: 'Cribl',
}

export const QuoteCribl2: Quote = {
  cite: 'Priya Gupta, Head of Data at Cribl',
  logo: customerLogos.cribl,
  quote: `Most of our logic lives in dbt. Omni automatically absorbs this metadata, which makes it really easy and fast to rebuild dashboards.`,
  cta: '/blog/case-study-cribl',
  title: 'Cribl',
}

export const QuoteCribl3: Quote = {
  cite: 'Head of Data at Cribl',
  logo: customerLogos.cribl,
  quote: `We love dbt because it makes it so easy to apply Cribl's lens of the business on top of our data; it's our single source of truth. Omni's deep integration with dbt allows us to expose more of that context to our stakeholders right where they consume data.`,
  cta: '/blog/case-study-cribl',
  title: 'Cribl',
}

export const QuoteCaraway: Quote = {
  cite: 'Kyle Turadek, Senior Director of Growth & E-Commerce',
  logo: customerLogos.caraway,
  quote: `Dynamic dashboards help us track the pulse of the business and the ad-hoc workbooks help us go deep without needing to bounce between tools. The trust and speed we get removes friction, saves hours, and empowers everyone to make informed decisions which shows up in how quickly we align and act.`,
  cta: '/blog/case-study-caraway',
  title: 'Caraway',
}

export const QuoteSecoda: Quote = {
  cite: 'Ainslie Eck, Data Governance Specialist at Secoda',
  logo: customerLogos.secoda,
  quote: `Omni gives data teams the structure of a semantic layer with the flexibility of modern dashboarding. Metrics are defined once and reused across models, workbooks, and dashboards. This reduces the risk of conflicting logic and ensures teams are working from the same definitions.`,
  cta: 'https://www.secoda.co/blog/secoda-integration-omni',
  title: 'Secoda',
}

export const QuoteInfiniteLamda: Quote = {
  cite: 'Nas Radev, CEO of Infinite Lambda',
  logo: customerLogos.infiniteLambda,
  quote: `We're seeing a seismic wave of clients looking to upgrade the BI tools that were built more than a decade ago. The modern data stack has evolved, and with AI accelerating how quickly users can ask questions and get answers, data teams are underserved with legacy platforms. Omni marries the ways users have always wanted to analyze data – SQL, point and click, and Excel – with AI experiences that are customizable, scalable and reliable.`,
  title: 'Infinite Lambda',
}

export const QuotePhData: Quote = {
  cite: 'Baxter Boe, SVP of Analytics & Agentic Activation',
  logo: customerLogos.phData,
  quote: `Many of our customers come to us wanting to consolidate use cases across tools and reduce BI sprawl; Omni is the perfect platform to do that. We're excited to partner with them on delivering widespread self-service analytics and reliable AI querying to our customers.`,
  title: 'phData',
}

export const QuoteAstroData: Quote = {
  cite: 'Spencer Taylor, Co-Founder @ Astrodata',
  logo: customerLogos.astroData,
  quote: `Omni is on the cutting edge of delivering the ability for end users to access data no matter their background. Our clients have been able to operate their data teams like product organizations with Omni — building features to enable widespread analytics, rather than a traditional pattern of taking tickets to answer business questions.`,
  title: 'Astro Data',
}

export const QuoteShearwater: Quote = {
  cite: 'Jeff Garcia, CEO at Shearwater Data',
  logo: customerLogos.shearwater,
  quote: `Omni adoption is on a meteoric rise, and for good reason. It has artfully balanced the scalability of a semantic layer with the flexibility of ad-hoc exploration. Its AI capabilities are the best AI features we have seen in any BI platform. Most importantly, Omni's unwavering commitment to customer success makes it our top recommendation.`,
  title: 'Shearwater',
}

export const QuoteSynthesia: Quote = {
  cite: 'Edward Mancey, GTM & Ops Data Lead',
  logo: customerLogos.synthesia,
  quote: `Just as we develop AI prompts for our own product, we can give Omni instructions on which columns we want to include and how we want it to interpret our data. Omni's AI will query the correct data across product, sales, and operations, and give answers that actually recommend actions to take.`,
  title: 'Synthesia',
  cta: '/blog/case-study-synthesia',
}

export const QuoteSynthesia2: Quote = {
  cite: 'Edward Mancey, Director of Data',
  logo: customerLogos.synthesia,
  quote: `I had experience with semantic layers, but modeling in Omni is so much faster and lighter. Other tools make data modeling feel like extra work; Omni makes it part of the workflow and opens it up to business users so they can add business context only they know.`,
  title: 'Synthesia',
  cta: '/blog/case-study-synthesia',
}

export const QuoteSynthesiaModeling: Quote = {
  cite: 'Edward Mancey,\nDirector of Data, Synthesia',
  logo: customerLogos.synthesia,
  quote: `Omni flips the traditional data model workflow. Instead of the data team coding every metric definition, business users can define them directly in the UI, using Excel-style formulas or point-and-click. The data team then reviews these definitions in a git workflow, and once they're ready, promotes those definitions across the company for reuse. It's how we move fast without sacrificing trust.`,
  title: 'Synthesia',
}

// export const QuoteWorkRamp: Quote = {
//   cite: 'Arsh Mand, CTO & Co-founder of WorkRamp',
//   logo: customerLogos.workRamp,
//   quote: `Omni gives our customers power without overwhelming them. And with AI, analyzing and understanding data within our platform is even more accessible to our diverse user base.`,
//   title: 'WorkRamp',
//   cta: '/blog/case-study-workramp',
// }

export const QuoteBambooHR: Quote = {
  cite: 'Thomas Stockham, Senior Product Manager, Data & AI',
  logo: customerLogos.bambooHR,
  quote: `Instead of spending months rebuilding dashboards, we're thinking about how to use AI to remove reporting work altogether. Our team is pushing the business forward because Omni has unlocked capacity for us.`,
  title: 'BambooHR',
  cta: '/blog/case-study-bamboohr',
}

export const QuoteHeidi: Quote = {
  cite: 'Head of Data at Heidi',
  logo: customerLogos.heidi,
  quote: `Omni’s AI does well because it’s backed by a structured data model. Now, it’s easier for us to train it like we would teach an analyst — giving it the right context to understand our business language and definitions. Omni’s already ahead of the curve because its semantic layer was built to enable AI from the start.`,
  cta: '/blog/case-study-heidi',
  title: 'Heidi',
}

export const QuoteBrevo: Quote = {
  cite: 'Taha Le Bras, Lead Analytics Engineer, Brevo',
  logo: customerLogos.brevo,
  quote: `No BI tool had solved custom fields well before. With Omni, our customers get to use personalized fields just like any other dimension, without needing us to hand-code each one. It's clean, it's simple, and it solves a challenge I've seen for years.`,
  cta: '/blog/case-study-brevo',
  title: 'Brevo',
}

export const QuoteGuitarCenter: Quote = {
  cite: 'Mike Doll, VP of Data',
  logo: customerLogos.guitarCenter,
  quote: `Choosing Omni is solving for more than just BI. We've also primed ourselves to leap forward into AI because the semantic model is at the heart of the platform. That's not true for many other tools.`,
  title: 'Guitar Center',
  cta: '/blog/case-study-guitar-center',
}

export const QuoteCheckr3: Quote = {
  cite: 'Sarah Fischbach, Senior Staff Analytics Engineer, Checkr',
  logo: customerLogos.checkr,
  quote: `The semantic layer gives you the building blocks — the fields, joins, and metric definitions. But it doesn't tell the AI how to assemble them for a specific kind of question; that’s where Omni’s AI context comes in.`,
  cta: '/blog/case-study-checkr',
  title: 'Checkr',
}

export const QuoteBambooHR2: Quote = {
  cite: 'Thomas Stockham, Senior Product Manager, Data & AI',
  logo: customerLogos.bambooHR,
  quote: `We knew data could be a compelling reason for customers to spend more time engaging in our product. Omni helped us transform our in-app analytics into a differentiated, customized experience — without requiring our engineering team to go build a BI product ourselves.`,
  cta: '/blog/case-study-bamboohr',
  title: 'BambooHR',
}

export const QuotePhotoroom: Quote = {
  cite: 'Juliette Duizabo, Head of Data',
  logo: customerLogos.photoroom,
  quote: `Before, answering a follow-up question could take up to five days. With Omni, it takes seconds.`,
  cta: '/blog/case-study-photoroom',
  title: 'Photoroom',
}

export const QuoteMeAndU: Quote = {
  cite: 'Tom Imbert, Director of Data & Analytics',
  logo: customerLogos.meAndU,
  quote: `The whole point of Omni is that whatever entry point people are most comfortable with, whether it’s a workbook, Blobby [Omni’s AI agent], or Claude, it’s the same governed model underneath. Same joins, definitions, and access controls.`,
  cta: '/blog/case-study-meandu',
  title: 'Me&U',
}

export const QuoteBrevo2: Quote = {
  cite: 'Taha Le Bras, Lead Analytics Engineer, Brevo',
  logo: customerLogos.brevo,
  quote: `It would have taken several teams months of engineering time to build less than 10 percent of what we’ve built in Omni.`,
  cta: '/blog/case-study-brevo',
  title: 'Brevo',
}

export const QuoteCaraway2: Quote = {
  cite: 'Maryssa Brogis, Senior Director of Analytics & Insights, Caraway',
  logo: customerLogos.caraway,
  quote: `From the beginning, Omni felt like a true partner. They listened to our needs, respected our bandwidth during busy seasons, and helped us find a solution that worked for our entire organization, not just the data team.`,
  cta: '/blog/case-study-caraway',
  title: 'Caraway',
}

export const QuoteCheckr4: Quote = {
  cite: 'Christian Shrader, Operations, Checkr',
  logo: customerLogos.checkr,
  quote: `What would have taken hours got done in minutes, with enough directional clarity to actually change how we responded.`,
  cta: '/blog/case-study-checkr',
  title: 'Checkr',
}
